import { AdminHeader } from '../components/admin/AdminHeader';
import { CustomInstancesIndex } from '../components/admin/custom/CustomInstancesIndex';

export function CustomInstancesPage() {
  return <div className="min-h-screen py-8">
    <div className="container mx-auto px-4">
      <AdminHeader activeTab="custom-instances" />
      <CustomInstancesIndex />
    </div>
  </div>;
}
